import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import { parsePhoneNumberFromString, isValidPhoneNumber, AsYouType } from 'libphonenumber-js';

import useForm from "../../hooks/useForm";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import { MOBILE_MONEY_PROVIDERS, BANK_OPTIONS } from "../../constants/commonConstants";

import { useThunk } from "../../hooks/useThunk";
import { signup, valildatePayoutMobileNumber, checkEmail } from "../../store";

import CustomInput from "../Form/Input";
import CustomButton from "../Form/CustomButton";
import ProfileImageUploader from "../Form/ProfileImageUploader";
import Dropdown from "../Form/Dropdown";
import showToast from "../../utils/toastNotifications";
import useFirebaseFileUpload from "../../hooks/useFirebaseFileUpload";
import { firebaseUplaodFolders } from "../../constants/commonConstants";

const LandLodRegistration = () => {
    const [profilePicture, setProfilePicture] = useState(null);
    const [currentStep, setCurrentStep] = useState(1); // Step 1: Personal Info, Step 2: Payout Info
    const [paymentMethod, setPaymentMethod] = useState("mobile");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const [mobileMoneyNumberError, setMobileMoneyNumberError] = useState("");
    const [emailError, setEmailError] = useState("");

    const [doSignup, isSigningUp, signupError] = useThunk(signup);
    const [doUploadRefrencesToFirebase,isUploadRefrencesToFirebaseLoading,uploadRefrencesToFirebaseError] = useFirebaseFileUpload();
    const [doValidatePayoutMobileNumber, isValidatingPayoutMobileNumber, validatePayoutMobileNumberError] = useThunk(valildatePayoutMobileNumber);
    const [doCheckEmail, isCheckingEmail, checkEmailError] = useThunk(checkEmail);

    const navigate = useNavigate();

    const headerStyles =
        "text-level-5 sm:text-[30px] font-alexandria font-semibold text-blue mb-2 sm:mb-3";
    const subHeaderStyle =
        "text-level-7 sm:text-[20px] font-alexandria font-medium text-dark-blue-text mb-2 sm:mb-3";
    const labelStyles =
        "text-[12px] sm:text-[16px] font-alexandria font-medium text-primary-text mb-0 sm:mb-3";
    const customStyle =
        "w-full h-8 sm:h-14 text-[12px] sm:text-[16px] font-normal font-alexandria text-primary-text border border-[#B9C1CA] placeholder:font-inter placeholder:text-placeholder-text placeholder:text-[12px] sm:placeholder:text-[16px]";
    const passwordStyle =
        `w-full h-8 sm:h-14 font-normal font-alexandria text-primary-text border border-[#B9C1CA] placeholder:font-inter placeholder:text-placeholder-text placeholder:text-[12px] sm:placeholder:text-[16px]
        ${ showPassword ? "text-[12px] sm:text-[16px]" : "text-[16px] sm:text-[20px]" }`
    const confirmpasswordStyle =
        `w-full h-8 sm:h-14 font-normal font-alexandria text-primary-text border border-[#B9C1CA] placeholder:font-inter placeholder:text-placeholder-text placeholder:text-[12px] sm:placeholder:text-[16px]
        ${ showConfirmPassword ? "text-[12px] sm:text-[16px]" : "text-[16px] sm:text-[20px]" }`

    const {
        formData,
        errors,
        touched,
        handleInputChange,
        handleBlur,
        validateForm,
        setTouched,
        clearError,
    } = useForm(
        {
            // Personal information fields
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            password: "",
            confirmPassword: "",
            // Mobile money fields
            mobileMoneyProvider: "",
            accountHolderName: "",
            mobileMoneyNumber: "",
            // Bank transfer fields
            // bankName: "",
            // accountNumber: "",
            // beneficiaryName: "",
            // bankCode: "",
        },
        {
            firstName: true,
            lastName: true,
            email: true,
            phoneNumber: true,
            password: true,
            confirmPassword: true,
            // Mobile money fields
            mobileMoneyProvider: true,
            accountHolderName: true,
            mobileMoneyNumber: true,
            // Bank transfer fields
            // bankName: true,
            // accountNumber: true,
            // beneficiaryName: true,
            // bankCode: true,
        },
        {
            firstName: COMMON_FIELD_TYPES.FIRST_NAME,
            lastName: COMMON_FIELD_TYPES.LAST_NAME,
            email: COMMON_FIELD_TYPES.EMAIL_FIELD,
            phoneNumber: COMMON_FIELD_TYPES.REQUIRED_FIELD,
            password: COMMON_FIELD_TYPES.PASSWORD_FIELD,
            confirmPassword: COMMON_FIELD_TYPES.CONFIRM_PASSWORD,
            // Mobile money fields
            mobileMoneyProvider: COMMON_FIELD_TYPES.DROPDOWN,
            accountHolderName: COMMON_FIELD_TYPES.FULLNAME,
            mobileMoneyNumber: COMMON_FIELD_TYPES.REQUIRED_FIELD,
            // Bank transfer fields
            // bankName: COMMON_FIELD_TYPES.DROPDOWN,
            // accountNumber: COMMON_FIELD_TYPES.REQUIRED_FIELD,
            // beneficiaryName: COMMON_FIELD_TYPES.FULLNAME,
            // bankCode: COMMON_FIELD_TYPES.REQUIRED_FIELD,
        }
    );

    // FUNCTION: Handle Profile Image Upload
    const handleProfileImageUpload = (file) => {
        setProfilePicture(file);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
    }

    const handleButtonClick = async () => {
        if (currentStep === 1) {
            setTouched({
                firstName: true,
                lastName: true,
                email: true,
                phoneNumber: true,
                password: true,
                confirmPassword: true,
            });
            validateForm();
            setPhoneNumberError(validateInternationalPhoneNumber(formData.phoneNumber));

            if (
                !formData.firstName || 
                !formData.lastName ||
                !formData.email ||
                !formData.phoneNumber ||
                !formData.password || 
                !formData.confirmPassword 
            ) {
                return;
            }

            const isAvailableEmail = await handleEmailCheck(formData.email);

            if (
                !errors.firstName &&
                !errors.lastName &&
                !errors.email &&
                !phoneNumberError && 
                !errors.password &&
                !errors.confirmPassword &&
                !emailError &&
                isAvailableEmail
            ) {
                setCurrentStep(2);
            }
        } else {
            // Final submission
            if (paymentMethod === "mobile") {
                setTouched({
                    mobileMoneyProvider: true,
                    accountHolderName: true,
                    mobileMoneyNumber: true,
                });
            } else if (paymentMethod === "bank") {
                setTouched({
                    bankName: true,
                    accountNumber: true,
                    beneficiaryName: true,
                    bankCode: true,
                });
            }

            validateForm();

            if (formData.mobileMoneyNumber) {
                const number = formData.mobileMoneyNumber.replace(/[^\d+]/g, '');
                const result = await doValidatePayoutMobileNumber({ mobileNumber: number });
                if (!result.success) {
                    showToast("error", result.error?.message || "Mobile money number validation failed.");
                    return;
                }
            }
            
            
            let uploadedProfilePictureUrl = profilePicture || null;
            if(!(profilePicture === null)) {
                // Upload profile picture to Firebase
                const uploadProfilePictureResult = await doUploadRefrencesToFirebase([profilePicture],firebaseUplaodFolders.F_PROFILE_PICTURES);

                if (!uploadProfilePictureResult.success) { 
                    showToast("error", "Failed to upload Profile Picture.");
                    return;
                }

                uploadedProfilePictureUrl = uploadProfilePictureResult.uploadedUrls[0];
                setProfilePicture(uploadedProfilePictureUrl);
                
                if ( !uploadedProfilePictureUrl || typeof uploadedProfilePictureUrl !== "string" ) {
                    showToast("error", "Invalid profile picture URL after upload.");
                    return;
                }
            }
            
            // const cleanPhoneNumber = '0'+formData.phoneNumber.replace(/\s+/g, '').slice(4); // Remove +256 prefix and spaces

            // Prepare userData for API
            let userData = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phoneNumber: formData.phoneNumber,
                password: formData.password,
                profilePicture: uploadedProfilePictureUrl,
                payout: {},
            };

            if (
                paymentMethod === "mobile" &&
                !errors.mobileMoneyProvider &&
                !errors.accountHolderName &&
                !errors.mobileMoneyNumber &&
                !errors.firstName &&
                !errors.lastName &&
                !errors.email &&
                !errors.phoneNumber &&
                !errors.password &&
                !errors.confirmPassword
            ) {
                userData.payout = {
                    method: "MOBILE_MONEY",
                    mobileMoney: {
                        mobileMoneyProvider: formData.mobileMoneyProvider,
                        accHolderFullName: formData.accountHolderName,
                        mobileNumber: formData.mobileMoneyNumber,
                    }
                };
            } else if (
                paymentMethod === "bank" &&
                !errors.bankName &&
                !errors.accountNumber &&
                !errors.beneficiaryName &&
                !errors.bankCode &&
                !errors.firstName &&
                !errors.lastName &&
                !errors.email &&
                !errors.phoneNumber &&
                !errors.password &&
                !errors.confirmPassword
            ) {
                userData.payout = {
                    method: "BANK",
                    bankDetails: {
                        bankName: formData.bankName,
                        accHolderFullName: formData.beneficiaryName,
                        accNumber: formData.accountNumber,
                        branchName: formData.bankCode,
                    },
                };
            } else {
                return;
            }
            
            // Call doSignup thunk
            const response = await doSignup(userData);

            if (response?.success) {
                showToast("success", "Registration successful! Please sign in.");
                navigate("/signin");
            } else {
                showToast("error", response?.error?.message || "Registration failed. Please try again.");  
                console.error("Registration error:", response);
            }
        }
    };

    const handleBack = () => {
        setCurrentStep(1);
    };

    const handlePaymentMethodChange = (method) => {
        setPaymentMethod(method);
    };

    const formatPhoneNumber = (value) => {
        // Remove all non-digit characters except +
        let cleaned = value.replace(/[^\d+]/g, '');

        // Only apply format if it starts with +256
        if (!(cleaned.startsWith('+256') || value.startsWith('+'))) {
            cleaned = `+256 ${value}`;
        }
        

        // Remove +256 prefix to format the rest
        let numberPart = cleaned.slice(4).replace(/\s+/g, '');

        // Apply formatting: 4-3-3 digits
        let formatted = '+256';
        if (numberPart.length > 0) {
            formatted += ' ' + numberPart.slice(0, 3);
        }
        if (numberPart.length > 3) {
            formatted += ' ' + numberPart.slice(3, 6);
        }
        if (numberPart.length > 6) {
            formatted += ' ' + numberPart.slice(6, 9);
        }

        return formatted.trim();
    };

    const formatInternationalPhoneNumber = (input) => {
        // Remove any existing formatting first
        let cleanInput = input.replace(/[^\d+]/g, '');
        
        // If input doesn't start with +, and has digits, assume it needs country code
        if (cleanInput && !cleanInput.startsWith('+')) {
                cleanInput = '+' + cleanInput;
        }
        
        // Use AsYouType for real-time formatting
        const formatter = new AsYouType();
        const formatted = formatter.input(cleanInput);
        

        return formatted;
    };

    const validateInternationalPhoneNumber = (phoneNumber) => {
        if (!phoneNumber || phoneNumber.trim().length < 0) {
            return "Phone number is required";
        }

        if (!isValidPhoneNumber(phoneNumber)) {
            return "Please enter a valid phone number";
        }

        try {
            const parsed = parsePhoneNumberFromString(phoneNumber);
            
            if (!parsed) {
                return "Please enter a valid phone number with country code";
            }

            if (!parsed.isValid()) {
                return "Please enter a valid phone number";
            }

            return null; // Valid
        } catch (error) {
            return "Please enter a valid international phone number";
        }
    };

    const handleEmailCheck = async (email) => {
        if (!email || !email.includes('@')) {
            setEmailError("");
            return;
        }

        const result = await doCheckEmail(email);
        if (result.success) {
            // Email is available
            setEmailError("");
            return true;
        } else {
            // Email already exists
            setEmailError(result.error?.message || "This email is already registered");
            return false;
        }
    };

    const NAME_REGEX = /^[A-Za-z ]+$/;

    const firstNameFormatError =
    formData.firstName && !NAME_REGEX.test(formData.firstName)
        ? "Only letters and spaces are allowed."
        : "";

    const lastNameFormatError =
    formData.lastName && !NAME_REGEX.test(formData.lastName)
        ? "Only letters and spaces are allowed."
        : "";

    const accountHolderNameFormatError =
    formData.accountHolderName && !NAME_REGEX.test(formData.accountHolderName)
        ? "Only letters and spaces are allowed."
        : "";

        const validateMobileMoneyNumber = (phone) => {
        if (!phone || phone.trim().length === 0) return "Mobile money number is required";
        if (!isValidPhoneNumber(phone)) return "Please enter a valid mobile money number";
        try {
            const parsed = parsePhoneNumberFromString(phone);
            if (!parsed) return "Please enter a valid mobile money number with country code";
            if (!parsed.isValid()) return "Please enter a valid mobile money number";
            return "";
        } catch {
            return "Please enter a valid international mobile money number";
        }
        };

    // Keep validations synced as the user types, so buttons enable/disable live
    useEffect(() => {
        validateForm();
    }, [formData, currentStep, validateForm]);

    const step1Required = [
        "firstName",
        "lastName",
        "email",
        "phoneNumber",
        "password",
        "confirmPassword",
    ];
    const step2Required = [
        "accountHolderName",
        "mobileMoneyProvider",
        "mobileMoneyNumber",
    ];

    const hasStep1FormatErrors = Boolean(firstNameFormatError || lastNameFormatError);
    const hasStep2FormatErrors = Boolean(accountHolderNameFormatError);

    const hasStep2Empty = step2Required.some((f) => !formData[f]);
    const hasStep2FieldErrors = step2Required.some((f) => !!errors[f]);
    const hasStep1Empty = step1Required.some((f) => !formData[f]);
    const hasStep1FieldErrors = step1Required.some((f) => !!errors[f]);
    const isStep1Valid =
        !hasStep1Empty &&
        !hasStep1FieldErrors &&
        !phoneNumberError &&
        !emailError &&
        !hasStep1FormatErrors;

    const isMobileFieldsFilled =
        !!formData.mobileMoneyProvider &&
        !!formData.accountHolderName &&
        !!formData.mobileMoneyNumber;
    const hasMobileFieldErrors =
        !!errors.mobileMoneyProvider ||
        !!errors.accountHolderName ||
        !!errors.mobileMoneyNumber;
    const isStep2Valid =
        !hasStep2Empty &&
        !hasStep2FieldErrors &&
        (paymentMethod === "mobile" || paymentMethod === "") &&
        isMobileFieldsFilled &&
        !hasMobileFieldErrors &&
        !hasStep2FormatErrors &&
        !mobileMoneyNumberError;
    return (
        <div className="flex items-center justify-center">
            <div className="w-full h-full max-w-6xl rounded-lg bg-background shadow-form">
                <div className="w-full h-full min-h-[600px] md:min-h-[735px] p-4 sm:p-6 flex flex-col justify-between ">
                    <div>
                        <h2 className={headerStyles}>Landlord Registration</h2>

                        {currentStep === 1 ? (
                            <>
                                <p className={subHeaderStyle}>Personal Information</p>

                                {/* Profile Picture  */}
                                <div className="flex justify-center mb-2 sm:mb-4">
                                    <ProfileImageUploader
                                        isRequired={false}
                                        avatarContainerStyle="w-24 sm:w-32"
                                        imageStyle="w-24 h-24 sm:w-32 sm:h-32"
                                        labelStyle="font-alexandria font-medium text-primary-text"
                                        isDisabled={false}
                                        loading={false}
                                        image={profilePicture}
                                        onImageUpload={handleProfileImageUpload}
                                        selectedImage={profilePicture}
                                    />
                                </div>
                            </>
                        ) : (
                            <p className={subHeaderStyle}>Payout Information</p>
                        )}

                        <form className="flex flex-col " onSubmit={handleSubmit}>
                            <div>
                                {currentStep === 1 ? (
                                    <div>
                                        {/* Personal Information Fields */}
                                        {/* First and Last Name */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mb-0 sm:gap-6 sm:mb-4">
                                            <CustomInput
                                                label="First Name"
                                                labelStyle={labelStyles}
                                                isRequired={true}
                                                name="firstName"
                                                placeholder="Enter your first name"
                                                value={formData.firstName}
                                                error={touched.firstName && (errors.firstName || firstNameFormatError)}
                                                onChange={(e) =>
                                                    handleInputChange(
                                                        "firstName",
                                                        e.target.value.charAt(0).toUpperCase() +
                                                        e.target.value.slice(1)
                                                    )
                                                }
                                                onBlur={() => { handleBlur("firstName", formData.firstName);
                                                    if (NAME_REGEX.test(formData.firstName)) {
                                                    handleInputChange(
                                                        "firstName",
                                                        formData.firstName.charAt(0).toUpperCase() + formData.firstName.slice(1)
                                                    );
                                                    }
                                                }}
                                                className={customStyle}
                                                inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                            />

                                            <CustomInput
                                                label="Last Name"
                                                labelStyle={labelStyles}
                                                isRequired={true}
                                                name="lastName"
                                                placeholder="Enter your last name"
                                                value={formData.lastName}
                                                error={touched.lastName && (errors.lastName || lastNameFormatError)}
                                                onBlur={() => { handleBlur("lastName", formData.lastName);
                                                    if (NAME_REGEX.test(formData.lastName)) {
                                                    handleInputChange(
                                                        "lastName",
                                                        formData.lastName.charAt(0).toUpperCase() + formData.lastName.slice(1)
                                                    )
                                                    }
                                                }}                                                
                                                onChange={(e) =>
                                                    handleInputChange(
                                                        "lastName",
                                                        e.target.value.charAt(0).toUpperCase() +
                                                        e.target.value.slice(1)
                                                    )
                                                }
                                                className={customStyle}
                                                inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                            />
                                        </div>

                                        {/* Email and Phone number*/}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mb-0 sm:gap-6 sm:mb-4">
                                            <CustomInput
                                                label="Email Address"
                                                labelStyle={labelStyles}
                                                isRequired={true}
                                                name="email"
                                                type="email"
                                                placeholder="Enter your email address"
                                                value={formData.email}
                                                error={touched.email && (errors.email || emailError)}
                                                onChange={(e) => {
                                                    const email = e.target.value.toLowerCase();
                                                    handleInputChange("email", email);
                                                    setEmailError(""); // Clear previous error
                                                }}
                                                onBlur={() => {
                                                    handleBlur("email", formData.email);
                                                    handleEmailCheck(formData.email);
                                                }}
                                                className={customStyle}
                                                inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                loading={isCheckingEmail}
                                            />
                                            <CustomInput
                                                label="Phone Number"
                                                labelStyle={labelStyles}
                                                isRequired={true}
                                                name="phoneNumber"
                                                placeholder="+256 XXX XXX XXX"
                                                value={formData.phoneNumber}
                                                error={touched.phoneNumber && phoneNumberError}
                                                onChange={(e) => {
                                                    handleInputChange("phoneNumber", e.target.value);
                                                    setTouched((prev) => ({ ...prev, phoneNumber: true }));
                                                    setPhoneNumberError(validateInternationalPhoneNumber(e.target.value));
                                                }}
                                                onBlur={() =>{
                                                    const formatted = formatInternationalPhoneNumber(formData.phoneNumber);
                                                    handleInputChange("phoneNumber", formatted);
                                                    handleBlur("phoneNumber", formatted);
                                                    setPhoneNumberError(validateInternationalPhoneNumber(formatted));
                                                }}
                                                // onFocus={() => clearError("phoneNumber")}
                                                className={customStyle}
                                                inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                            />
                                        </div>

                                        {/* Password and Confirm Password */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mb-2 sm:gap-6 sm:mb-6">
                                            <div className="relative">
                                                <CustomInput
                                                label="Password"
                                                labelStyle={labelStyles}
                                                isRequired={true}
                                                name="password"
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Enter your password"
                                                value={formData.password}
                                                error={touched.password && errors.password}
                                                onChange={(e) =>
                                                    handleInputChange("password", e.target.value)
                                                }
                                                onBlur={() => handleBlur("password", formData.password)}
                                                // onFocus={() => clearError("password")}
                                                className={passwordStyle}            
                                                inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                />
                                                <span
                                                    className="absolute right-1 sm:right-3 top-[53%] sm:top-[60%] transform -translate-y-1/2 cursor-pointer p-2"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? ( 
                                                        <FiEye className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" /> 
                                                    ) : ( 
                                                        <FiEyeOff className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" /> 
                                                    )}
                                                </span>
                                            </div>

                                            <div className="relative">
                                                <CustomInput
                                                label="Confirm Password"
                                                labelStyle={labelStyles}
                                                isRequired={true}
                                                name="confirmPassword"
                                                type= {showConfirmPassword ? "text" : "password"}
                                                placeholder="Enter your password"
                                                value={formData.confirmPassword}
                                                error={touched.confirmPassword && errors.confirmPassword}
                                                onChange={(e) =>
                                                    handleInputChange("confirmPassword", e.target.value)
                                                }
                                                onBlur={() =>
                                                    handleBlur("confirmPassword", formData.confirmPassword)
                                                }
                                                // onFocus={() => clearError("confirmPassword")}
                                                className={confirmpasswordStyle}            
                                                inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                />
                                                <span
                                                    className="absolute right-1 sm:right-3 top-[53%] sm:top-[60%] transform -translate-y-1/2 cursor-pointer p-2"
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                >
                                                    {showConfirmPassword ? ( 
                                                        <FiEye className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" /> 
                                                    ) : ( 
                                                        <FiEyeOff className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" /> 
                                                    )}
                                                </span>

                                            </div>
                                            
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        {/* Payout Information Fields */}
                                        <div className="mb-4">
                                            {/* <label className={labelStyles}>
                                                Preferred Payout method
                                                <span className="text-red-500">*</span>
                                            </label>

                                            <div className="flex gap-6 mb-4">
                                                <div className="flex items-center">
                                                    <CustomInput
                                                        name="mobileMoney"
                                                        type="checkbox"
                                                        checked={paymentMethod === "mobile"}
                                                        onChange={() => handlePaymentMethodChange("mobile")}
                                                        className="flex-shrink-0 w-4 h-4 p-0 accent-primary"
                                                        outerContainerStyle="mt-3 p-0 flex items-center"
                                                    />
                                                    <span className="ml-2 text-[12px] sm:text-[16px] font-alexandria text-primary-text whitespace-nowrap">
                                                        Mobile money
                                                    </span>
                                                </div>
                                                <div className="flex items-center">
                                                    <CustomInput
                                                        name="bankTransfer"
                                                        type="checkbox"
                                                        checked={paymentMethod === "bank"}
                                                        onChange={() => handlePaymentMethodChange("bank")}
                                                        className="flex-shrink-0 w-4 h-4 p-0 accent-primary"
                                                        outerContainerStyle="mt-3 p-0 flex items-center"
                                                    />
                                                    <span className="ml-2 text-[12px] sm:text-[16px] font-alexandria text-primary-text whitespace-nowrap">
                                                        Bank Transfer
                                                    </span>
                                                </div>
                                            </div> */}

                                            {/* Mobile Money Fields */}
                                            {(paymentMethod === "mobile" || paymentMethod === "") && (
                                                <>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mb-0 sm:gap-6 sm:mb-4">
                                                        <Dropdown
                                                            label="Mobile Money Provider"
                                                            labelStyle={labelStyles}
                                                            outerContainerStyle={"gap-0"}
                                                            isRequired={true}
                                                            name="mobileMoneyProvider"
                                                            options={MOBILE_MONEY_PROVIDERS}
                                                            placeholder="Select mobile money provider"
                                                            buttonClassName="w-full h-8 sm:h-14 rounded-md bg-[#4772F1] bg-opacity-[0.03] text-primary-text font-alexandria text-[12px] sm:text-[16px] border border-[#B9C1CA]"
                                                            defaultOption={
                                                                formData.mobileMoneyProvider
                                                                    ? MOBILE_MONEY_PROVIDERS.find(provider => provider._id === formData.mobileMoneyProvider)
                                                                    : null
                                                            }
                                                            error={touched.mobileMoneyProvider && errors.mobileMoneyProvider}
                                                            onSelect={(option) =>
                                                                handleInputChange(
                                                                    "mobileMoneyProvider",
                                                                    option ? option._id : ""
                                                                )
                                                            }
                                                        />
                                                        <CustomInput
                                                            label="Account Holder Name"
                                                            labelStyle={labelStyles}
                                                            isRequired={true}
                                                            name="accountHolderName"
                                                            placeholder="Enter your mobile money account holders name"
                                                            value={formData.accountHolderName}
                                                            error={
                                                                touched.accountHolderName && (errors.accountHolderName || accountHolderNameFormatError)
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\b\w/g, char => char.toUpperCase());
                                                                handleInputChange("accountHolderName", value);
                                                            }}
                                                            // onBlur={() =>
                                                            //     handleBlur(
                                                            //         "accountHolderName",
                                                            //         formData.accountHolderName
                                                            //     )
                                                            // }
                                                            onBlur={() => { 
                                                                handleBlur(
                                                                    "accountHolderName",
                                                                    formData.accountHolderName
                                                                  );
                                                                if (NAME_REGEX.test(formData.accountHolderName)) {
                                                                    handleInputChange(
                                                                    "accountHolderName",
                                                                    formData.accountHolderName.charAt(0).toUpperCase() + formData.accountHolderName.slice(1)
                                                                )
                                                            }
                                                        }}    
                                                            // onFocus={() => clearError("accountHolderName")}
                                                            className={customStyle}
                                                            inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                        />
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mb-0 sm:gap-6 sm:mb-4">
                                                        <CustomInput
                                                            label="Mobile Money Number"
                                                            labelStyle={labelStyles}
                                                            isRequired={true}
                                                            name="mobileMoneyNumber"
                                                            type="tel"
                                                            placeholder="Enter mobile money number"
                                                            value={formData.mobileMoneyNumber}
                                                            error={
                                                                touched.mobileMoneyNumber && (errors.mobileMoneyNumber || mobileMoneyNumberError)
                                                            }
                                                            onChange={(e) =>{
                                                                handleInputChange("mobileMoneyNumber", e.target.value);
                                                            setTouched((prev) => ({ ...prev, mobileMoneyNumber: true }));
                                                            setMobileMoneyNumberError(validateMobileMoneyNumber(e.target.value));
                                                            }}
                                                            onBlur={() => {
                                                                const formatted = formatInternationalPhoneNumber(formData.mobileMoneyNumber);
                                                                handleInputChange("mobileMoneyNumber", formatted);
                                                                handleBlur("mobileMoneyNumber", formatted);
                                                                setMobileMoneyNumberError(validateMobileMoneyNumber(formatted));
                                                            }}
                                                            // onFocus={() => clearError("mobileMoneyNumber")}
                                                            className={customStyle}
                                                            inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            {/* Bank Transfer Fields */}
                                            {/* {paymentMethod === "bank" && (
                                                <>
                                                    <div className="grid grid-cols-1 gap-8 mb-4 md:grid-cols-2 sm:gap-6 sm:mb-4">
                                                        <Dropdown
                                                            label="Bank Name"
                                                            labelStyle={labelStyles}
                                                            outerContainerStyle={"gap-0"}
                                                            isRequired={true}
                                                            name="bankName"
                                                            options={BANK_OPTIONS}
                                                            placeholder="Select bank"
                                                            buttonClassName="w-full h-8 bg-[#4772F1] bg-opacity-[0.03] sm:h-14 rounded-md text-primary-text font-alexandria text-[12px] sm:text-[16px] border border-[#B9C1CA]"
                                                            defaultOption={
                                                                formData.bankName
                                                                    ? BANK_OPTIONS.find(bank => bank._id === formData.bankName)
                                                                    : null
                                                            }
                                                            error={touched.bankName && errors.bankName}
                                                            onSelect={(option) =>
                                                                handleInputChange(
                                                                    "bankName",
                                                                    option ? option._id : ""
                                                                )
                                                            }
                                                        />
                                                        <CustomInput
                                                            label="Account Number"
                                                            labelStyle={labelStyles}
                                                            isRequired={true}
                                                            name="accountNumber"
                                                            placeholder="Enter account number"
                                                            value={formData.accountNumber}
                                                            error={
                                                                touched.accountNumber && errors.accountNumber
                                                            }
                                                            onChange={(e) =>
                                                                handleInputChange("accountNumber", e.target.value)
                                                            }
                                                            onBlur={() =>
                                                                handleBlur(
                                                                    "accountNumber",
                                                                    formData.accountNumber
                                                                )
                                                            }
                                                            onFocus={() => clearError("accountNumber")}
                                                            className={customStyle}
                                                            inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                        />
                                                    </div>

                                                    <div className="grid grid-cols-1 gap-4 mb-6 md:grid-cols-2 sm:gap-6 sm:mb-6">
                                                        <CustomInput
                                                            label="Beneficiary Name"
                                                            labelStyle={labelStyles}
                                                            isRequired={true}
                                                            name="beneficiaryName"
                                                            placeholder="Enter beneficiary name"
                                                            value={formData.beneficiaryName}
                                                            error={
                                                                touched.beneficiaryName && errors.beneficiaryName
                                                            }
                                                            onChange={(e) =>
                                                                handleInputChange(
                                                                    "beneficiaryName",
                                                                    e.target.value
                                                                )
                                                            }
                                                            onBlur={() =>
                                                                handleBlur(
                                                                    "beneficiaryName",
                                                                    formData.beneficiaryName
                                                                )
                                                            }
                                                            onFocus={() => clearError("beneficiaryName")}
                                                            className={customStyle}
                                                            inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                        />
                                                        <CustomInput
                                                            label="Bank Code"
                                                            labelStyle={labelStyles}
                                                            isRequired={true}
                                                            name="bankCode"
                                                            placeholder="Enter bank code"
                                                            value={formData.bankCode}
                                                            error={touched.bankCode && errors.bankCode}
                                                            onChange={(e) =>
                                                                handleInputChange("bankCode", e.target.value)
                                                            }
                                                            onBlur={() =>
                                                                handleBlur("bankCode", formData.bankCode)
                                                            }
                                                            onFocus={() => clearError("bankCode")}
                                                            className={customStyle}
                                                            inputStyle="bg-[#4772F1] bg-opacity-[0.03]"
                                                        />
                                                    </div>
                                                </>
                                            )} */}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div>
                        {/* Buttons */}
                        <div
                            className={
                                currentStep === 2
                                    ? "flex justify-between gap-6"
                                    : "flex justify-center"
                            }
                        >
                            {currentStep === 2 && (
                                <CustomButton
                                    type="button"
                                    buttonText="Back"
                                    bgColor="bg-white"
                                    textColor="text-blue"
                                    className="w-full h-10 sm:h-14 text-[14px] sm:text-[18px] font-alexandria font-bold rounded-md border border-blue"
                                    onClick={handleBack}
                                />
                            )}
                            <CustomButton
                                type="button"
                                onClick={handleButtonClick}
                                buttonText={currentStep === 1 ? "Next" : "Register"}
                                bgColor="bg-main-header-gradient"
                                textColor="text-white"
                                disabled={currentStep === 1 ? !isStep1Valid : !isStep2Valid}
                                className={`w-full h-10 sm:h-14 text-[14px] sm:text-[18px] font-alexandria font-bold rounded-md ${
                                  (currentStep === 1 ? !isStep1Valid : !isStep2Valid)
                                    ? "opacity-60 cursor-not-allowed"
                                    : ""
                                }`}
                                loading={isSigningUp || isUploadRefrencesToFirebaseLoading || isValidatingPayoutMobileNumber}
                            />
                        </div>
                        <div
                            className={
                                "flex justify-center items-center mt-2 sm:mt-3 text-content-text text-[12px] sm:text-[15px] font-inter"
                            }
                        >
                            have an account?
                            <a href="/signin" className={"text-blue ml-1 underline"}>
                                Login
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandLodRegistration;
